import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-down"><path d="M4.36309 15.1384C3.68147 14.3249 4.25989 13.0856 5.32124 13.0856H8.00002V5.83565C8.00002 3.76458 9.67896 2.08565 11.75 2.08565H12.25C14.3211 2.08565 16 3.76458 16 5.83565V13.0856H18.6788C19.7402 13.0856 20.3186 14.3249 19.637 15.1384L13.7247 22.195C12.8254 23.2683 11.1746 23.2683 10.2754 22.195L4.36309 15.1384Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathDown;
